import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import Workflow from "./sections/Workflow";
import Briefing from "./sections/Briefing";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Portfolio />
      <Workflow />
      <Briefing />
      <Footer />
    </div>;
}